import React from "react"
import { readingTime as readingTimeHelper } from "@tryghost/helpers"

interface Props {
  post: any
}

const BlogAuthors: React.FC<Props> = ({ post }) => {
  const readingTime = readingTimeHelper(post)
  const { authors } = post

  const authorNames = authors.map((a) => a.name).join(", ")

  return (
    <div className="hstack gap-2 align-items-center">
      <ul className="author-list">
        {post.authors.map((author) => (
          <li className="author-list-item" key={author.id}>
            <span className="author-avatar">
              <img className="author-profile-image" src={author.profile_image} alt={author.name} />
            </span>
          </li>
        ))}
      </ul>
      <div className="vstack gap-1 align-self-center">
        <h4 className="author-name m-0 p-0">
          <span className="text-dark">{authorNames}</span>
        </h4>
        <div className="hstack gap-2 text-secondary" style={{ fontSize: "14px" }}>
          <time>{post.published_at_pretty}</time>
          {readingTime && (
            <>
              <span className="bull">&bull;</span>
              <span>{readingTime}</span>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
/** export */
export default BlogAuthors
